import type { AppState } from 'app/app-state';
import { NAME } from './constants';

export const getDomainState = (state: AppState) => state[NAME];
